import React from "react";
import { connect } from "react-redux";
//import ConsoleView from './ConsoleView'
import { loginToBattleNetwork } from "./connection/firebase-auth";
// import SetNameScreen from "./SetNameScreen.js";
import { getQueryVariable } from "../helpers/get-query-variable.js";
import { setMatchmakingValue } from "../redux-actions/battle-actions.js";
import OpenBattleLobby from "./RallyBattleLobby";
import FullteamBattleLobby from "./FullteamBattleLobby";
import OnlineBattleContainer from "./OnlineBattleContainer";
import EditCombatantModal from "../b5-crew-management/EditCombatantModal.js";
import FullscreenState from '../b5-home/FullscreenState'

//TODO: This name needs to change, but I'm not sure what to call it yet
class BattleLoginWall extends React.Component {
  componentWillMount() {
    //Look at the URL to see if we have a specific room to join.
    const partyIdFromUrl = getQueryVariable("p");
    if (partyIdFromUrl) {
      setMatchmakingValue({
        redirectToRoom: partyIdFromUrl
      });
    }

    //Find a room, put us in it
    loginToBattleNetwork();
  }

  renderNotificationMessage() {
    //This is a MatchkingErrorMessage flow type:
    const model = this.props.matchmakingErrorMsg; //will always be the Flow type^^
    if (model.status === "None") {
      return <div>model status is NONE</div>;
    }

    if (model.status === "Error") {
      return (
        <div className="error-text">
          {model.message}
        </div>
      );
    }

    return (
      <div>
        {model.message}
      </div>
    );
  }

  renderBattle() {
    //rename this?

    //Show a Lobby screen if battle has not started
    if (!this.props.hasBattleStarted) {
      if (this.props.currentRoomType === "fullteam") {
        return <FullteamBattleLobby />;
      }
      if (this.props.currentRoomType === "open") {
        return <OpenBattleLobby />;
      }
      return null;
    }

    const { combatants, teams } = this.props;

    //First render will may not have combatants or teams set. (need to initBattle earlier)
    if (
      !teams ||
      Object.keys(combatants).length === 0 ||
      Object.keys(teams).length === 0
    ) {
      //console.warn('Warning! Tried to render but Combatants and Teams are not set');
      // console.log("teams and combatants not yet set for Online battle");

      return null;
    }

    //Online Arena in game frame
    return <OnlineBattleContainer />;
  }

  renderInnerContent() {
    //Case 1: We successfully joined the room and know the room Type
    if (
      this.props.userDataState === "Success" &&
      (this.props.currentRoomType === "fullteam" || this.props.currentRoomType === "open")
    ) {
      //TODO: This probably needs to be like, "Check if we're in a battle"
      return this.renderBattle();
    }

    //Case 2: There is an error.
    const errorModel = this.props.matchmakingErrorMsg;
    if (this.props.matchmakingErrorMsg.status === "Error") {

      //Room is full
      if (errorModel.code === "error/full") {
        return (
          <FullscreenState>
            <div>
              <p className="ErrorStateText__text">This room is full!</p>
              <p className="ErrorStateText__text">Start another room, or configure your crew to be ready for the next battle.</p>
              <div>
                <a className="button large primary" href="/?online=y">New Versus Battle</a>
                <a className="button large" href="/">Go to Your Crew</a>
              </div>
            </div>
          </FullscreenState>
        )
      }

      //Battle has already started!
      if (errorModel.code === "error/started") {
        return (
          <FullscreenState>
            <div>
              <p className="ErrorStateText__text">Uh oh - This battle has already started!</p>
              <p className="ErrorStateText__text">Start another room, or configure your crew to be ready for the next battle.</p>
              <div>
                <a className="button large primary" href="/?online=y">New Versus Battle</a>
                <a className="button large" href="/">Go to Your Crew</a>
              </div>
            </div>
          </FullscreenState>
        )
      }
    }

    // console.log("render - >", this.props.userDataState, this.props.currentRoomType)
    //
    // console.log('err', this.props.matchmakingErrorMsg)
    // console.warn('unknown case in renderInnerContent')
    console.log('errorModel', errorModel)
    return null;
  }

  // renderDebugInfo() {
  //   const { battlePlayerId, currentRoomId } = this.props;
  //   const tempDebugStyle = {
  //     fontSize: "11px",
  //     position: "absolute",
  //     left: 0,
  //     top: 0,
  //     background: "#333",
  //     color: "#fff"
  //   };
  //
  //   const masterBadge = this.props.isMultiplayerMasterClient
  //     ? <span> | MASTER</span>
  //     : <span />;
  //   //const errorMsg = this.props.matchmakingErrorMsg ? <div className="error-text">{this.props.matchmakingErrorMsg}</div> : null
  //
  //   return (
  //     <div style={tempDebugStyle}>
  //       <div>
  //         You are: {battlePlayerId[0]}
  //       </div>
  //       <div>
  //         Room: {currentRoomId} {masterBadge}
  //       </div>
  //       {this.renderNotificationMessage()}
  //     </div>
  //   );
  // }

  /* Open the modal if we're open */
  renderEditCombatantModal() {
    if (this.props.editingCombatantProperties.isActivated) {
      return <EditCombatantModal />;
    }
    return null;
  }

  render() {
    //Loading and SetName screen
    if (this.props.userDataState === "Loading") {

      //Figuring out who you are...
      return null
    }

    if (this.props.isDuplicateEntryScreen) {
      return (
        <FullscreenState>
          <div>
            <p className="ErrorStateText__text">
            Warning! You are already connected to the battle system in another
            browser window! Please return to your other tab!
            </p>
            <div>
              <a className="button large" href="/">Home Screen</a>
            </div>
          </div>
        </FullscreenState>
      );
    }

    return (
      <div style={{ height: "100%" }}>
        {this.renderInnerContent()}
        {this.renderEditCombatantModal()}
      </div>
    );
  }
}

export default connect((state, props) => {
  return {
    vW: state.global.vW,
    isMultiplayerMasterClient: state.battle.isMultiplayerMasterClient,
    hasBattleStarted: state.battle.hasBattleStarted,
    battlePlayerId: state.battle.battlePlayerId,
    combatants: state.battle.combatants,
    teams: state.battle.teams,

    isDuplicateEntryScreen: state.matchmaking.isDuplicateEntryScreen,
    matchmakingErrorMsg: state.matchmaking.errorMessage,
    userDataState: state.matchmaking.userDataState,
    currentRoomId: state.matchmaking.currentRoomId,
    currentRoomType: state.matchmaking.currentRoomType,

    editingCombatantProperties: state.matchmaking.editingCombatantProperties
  };
})(BattleLoginWall);



// WEBPACK FOOTER //
// ./src/battle/BattleLoginWall.js